<template>
  <Layout>
    <div class="mc-report__delivery-plan-actual">
      <PageHeader
        :title="title"
        :items="breadcrumbItems"
        hasBreadcrumb
        hasBackButton
        routeBack="/report"
      >
        <template #afterTitle>
          <div class="d-flex align-items-center gap-2">
            <McListDownloader
              :pageOptions="downloadPageOptions"
              :fileFormatOptions="['excel']"
              @download="handleDownload"
            />
          </div>
        </template>
      </PageHeader>
      <TableReport
        :fields="fields"
        :apiClient="apiClient"
        @setParams="handleSetParams"
        @setMetadata="handleSetMetadata"
      />
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'

import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2'
import TableReport from './components/TableReport'
import McListDownloader from '@/components/McListDownloader'

import { fields } from './lib/fields/fields'
import * as Report from '@/services/rest-api/lib/report/report.js'
import omitBy from 'lodash/omitBy'

export default {
  page: {
    title: 'Report Delivery Plan vs Actual',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    TableReport,
    McListDownloader,
  },
  data() {
    return {
      params: {},
      metadata: null,
    }
  },
  computed: {
    title() {
      return 'Target vs Aktual Pengiriman'
    },
    breadcrumbItems() {
      return [
        {
          text: 'Laporan',
          to: '/report',
        },
        {
          text: 'Target vs Aktual Pengiriman',
        },
      ]
    },
    fields() {
      const computedFields = []
      fields().forEach((field) => {
        if (!field.isShow) return

        computedFields.push(field)
      })

      return computedFields
    },
    downloadPageOptions() {
      return [
        { label: this.$t('global.currentPage'), amount: this.metadata?.count, key: 'current_page' },
        { label: this.$t('global.allPages'), amount: this.metadata?.total_count, key: 'all' },
      ]
    },
    apiClient() {
      return {
        get: Report.getReportDeliveryPlanActual(this.handleSetParams, this.handleSetMetadata),
      }
    },
  },
  methods: {
    handleDownload(format, dataAmount) {
      // Remove undefined params
      const params = omitBy(
        {
          ...this.params,
          format,
        },
        (value) => value === undefined
      )

      if (dataAmount === 'all') {
        delete params['limit']
        delete params['page']
      }

      window.open(
        `${process.env.VUE_APP_API_ORDER_URL}/report/3?${new URLSearchParams(params).toString()}`,
        '_self'
      )
    },
    handleSetParams(params) {
      this.params = params
    },
    handleSetMetadata(metadata) {
      this.metadata = metadata
    },
  },
}
</script>
